<!-- 询比价管理  询价是采购商询价 供应商报价 -->
<template>
  <div class="">
    <div class="container">
      <el-tabs v-model="currentIndex" type="card" @tab-click="handleTab">
        <el-tab-pane
          v-for="(item, index) of tabArr"
          :key="index"
          :label="item.tabName"
          :name="`${index}`"
        ></el-tab-pane>
      </el-tabs>
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :count="6"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <!-- 操作按钮 -->
    <div
      class="handle-wrapper"
      style="display: flex; justify-content: end; margin-bottom: 20px"
    >
      <eui-btn @click="handleExport">导出询价单信息</eui-btn>
    </div>
    <div class="container">
      <eTableList
        :table-data="tableData"
        :loading="tableLoading"
        :table-label="formatTableLabel"
        :index-show="true"
      >
        <template #enquiryStatus="{ scope }">
          <span>{{ enquiryStatusObj[scope.row.enquiryStatus] }}</span>
        </template>
        <template #includeFreight="{ scope }">
          <span>{{ includeFreightTypeObj[scope.row.includeFreight] }}</span>
        </template>
        <template #aiReviewStatus="{ scope }">
          <span v-if="scope.row.aiReviewStatus === 0">分析中</span>
          <eui-btn
            v-else-if="
              scope.row.aiReviewStatus === 1 || scope.row.aiReviewStatus === 2
            "
            type="link"
            font-size="12px"
            @click="openAiReviewModal(scope.row)"
          >
            查看分析结果
          </eui-btn>

          <span v-else>-</span>
        </template>
        <template #isDoC="{ scope }">
          <span>{{ isDoCeObj[scope.row.isDoC] }}</span>
        </template>
        <template #shipmentType="{ scope }">
          <span>{{ shipmentTypeObj[scope.row.shipmentType] }}</span>
        </template>
        <template #createSource="{ scope }">
          <span>{{ createSourceTypeObj[scope.row.createSource] }}</span>
        </template>
        <template #quotationCount="{ scope }">
          <eui-btn
            v-if="scope.row.enquiryType === 0"
            type="link"
            font-size="12px"
            :disabled="configData === '132'"
            @click="configData === '131' && openSupplierPriceDia(scope.row)"
          >
            {{ showSupplierPrice(scope.row) }}
          </eui-btn>
          <eui-btn
            v-else-if="scope.row.enquiryType === 1"
            type="link"
            font-size="12px"
            :disabled="configData === '132'"
            @click="configData === '131' && openSupplierPriceDia(scope.row)"
          >
            {{ showSupplierPrice(scope.row) }}
          </eui-btn>
        </template>
        <template #handle="{ scope }">
          <eui-btn
            v-if="
              scope.row.createSource !== 2 &&
              (scope.row.enquiryStatus === 1 || scope.row.isCanCallBack === 1)
            "
            type="link"
            font-size="12px"
            @click="
              checkAuth(scope.row) && openDia('withdrawVisible', scope.row)
            "
          >
            撤回
          </eui-btn>
          <eui-btn
            v-if="
              scope.row.createSource !== 2 &&
              (scope.row.enquiryStatus === 2 || scope.row.enquiryStatus === 3)
            "
            type="link"
            font-size="12px"
            @click="checkAuth(scope.row) && openDia('backVisible', scope.row)"
          >
            回退
          </eui-btn>
          <eui-btn
            v-if="scope.row.createSource !== 2 && scope.row.isCanDelay === 1"
            type="link"
            font-size="12px"
            @click="checkAuth(scope.row) && openDia('delayVisible', scope.row)"
          >
            延时
          </eui-btn>
          <eui-btn
            v-if="
              scope.row.createSource !== 2 &&
              (scope.row.enquiryStatus === 0 ||
                scope.row.enquiryStatus === 9 ||
                scope.row.enquiryStatus === 13)
            "
            type="link"
            font-size="12px"
            class="table-handle-btn"
            @click="checkAuth(scope.row) && handleEdit(scope.row)"
          >
            编辑
          </eui-btn>
          <eui-btn
            v-if="scope.row.enquiryStatus !== 0"
            type="link"
            font-size="12px"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </eui-btn>
          <eui-btn
            v-if="scope.row.createSource !== 2 && scope.row.enquiryStatus === 4"
            type="link"
            font-size="12px"
            @click="checkAuth(scope.row) && chooseBusPrc(scope.row, 1)"
          >
            选商定价
          </eui-btn>
          <eui-btn
            v-if="scope.row.createSource !== 2 && scope.row.enquiryStatus === 5"
            type="link"
            font-size="12px"
            @click="checkAuth(scope.row) && goOrder(scope.row)"
          >
            生成订单
          </eui-btn>
          <eui-btn
            v-if="
              scope.row.createSource !== 2 &&
              (scope.row.enquiryStatus === 8 || scope.row.enquiryStatus === 10)
            "
            type="link"
            font-size="12px"
            @click="checkAuth(scope.row) && handleEdit(scope.row)"
          >
            重新询价
          </eui-btn>
          <eui-btn
            v-if="
              scope.row.createSource !== 2 &&
              (scope.row.enquiryStatus === 0 || scope.row.enquiryStatus === 8)
            "
            type="link"
            font-size="12px"
            @click="checkAuth(scope.row) && openDia('delVisible', scope.row)"
          >
            删除
          </eui-btn>
          <eui-btn
            v-if="
              scope.row.createSource !== 2 &&
              (scope.row.enquiryStatus === 4 ||
                scope.row.enquiryStatus === 10 ||
                scope.row.enquiryStatus === 14)
            "
            type="link"
            font-size="12px"
            @click="
              checkAuth(scope.row) && openDia('cancellationVis', scope.row)
            "
          >
            作废
          </eui-btn>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 删除弹窗 -->
    <prompt-modal
      :prompt-modal-visible="delVisible"
      :footer="true"
      @close="closeDia('delVisible')"
    >
      <div slot="title" class="prompt-modal-title">
        <!-- <img src="@/static/common/warnIcon.png" alt /> -->
        <p>删除操作</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <h4>您正在操作删除草稿，删除后无法恢复，是否继续？</h4>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" @click="closeDia('delVisible')"
          >关闭</el-button
        >
        <el-button
          v-prevent-re-click
          class="btn-80-30-primary"
          type="primary"
          @click="handleDel"
          >删除</el-button
        >
      </div>
    </prompt-modal>

    <!-- 作废弹窗 -->
    <prompt-modal
      :prompt-modal-visible="cancellationVis"
      :footer="true"
      @close="closeDia('cancellationVis')"
    >
      <div slot="title" class="prompt-modal-title">
        <!-- <img src="@/static/common/warnIcon.png" alt /> -->
        <p>作废操作</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <h4>
          {{ cancellationTitle }}
        </h4>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" @click="closeDia('cancellationVis')"
          >取消</el-button
        >
        <el-button
          class="btn-80-30-primary"
          type="primary"
          @click="handleCancellation"
          >确定作废</el-button
        >
      </div>
    </prompt-modal>

    <!-- 撤回弹窗 -->
    <prompt-modal
      :prompt-modal-visible="withdrawVisible"
      :footer="true"
      @close="closeDia('withdrawVisible')"
    >
      <div slot="title" class="prompt-modal-title">
        <!-- <img src="@/static/common/warnIcon.png" alt /> -->
        <p>撤回操作</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <h4>
          您正在操作询价单撤回操作，确认后询价单将变为草稿状态，是否继续？
        </h4>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" @click="closeDia('withdrawVisible')"
          >取消</el-button
        >
        <el-button
          v-prevent-re-click
          class="btn-80-30-primary"
          type="primary"
          @click="handleWithdraw('withdrawVisible')"
        >
          确定
        </el-button>
      </div>
    </prompt-modal>

    <!-- 回退弹窗 -->
    <prompt-modal
      :prompt-modal-visible="backVisible"
      :footer="true"
      @close="closeDia('backVisible')"
    >
      <div slot="title" class="prompt-modal-title">
        <!-- <img src="@/static/common/warnIcon.png" alt /> -->
        <p>回退操作</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <h4>
          您正在操作询价单回退操作，确认后询价单将变为草稿状态，重新发起询价需要审核后才可发布，是否继续？
        </h4>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" @click="closeDia('backVisible')"
          >取消</el-button
        >
        <el-button
          v-prevent-re-click
          class="btn-80-30-primary"
          type="primary"
          @click="handleBack('backVisible')"
        >
          确定
        </el-button>
      </div>
    </prompt-modal>

    <!-- 报价截止时间延时 弹窗 -->
    <prompt-modal
      :prompt-modal-visible="delayVisible"
      :footer="true"
      width="560px"
      @close="closeDia('delayVisible')"
    >
      <div slot="title" class="prompt-modal-title">
        <!--  <img src="@/static/common/warnIcon.png" alt /> -->
        <p>报价截止时间延时</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <el-form
          ref="delayForm"
          :model="delayForm"
          :rules="delayRules"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="询价单名称" prop="name">
            <span>{{ paramsRow.enquiryName }}</span>
          </el-form-item>
          <el-form-item label="报价截止时间" prop="quotationDeadline">
            <el-date-picker
              v-model="delayForm.quotationDeadline"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH"
              value-format="timestamp"
              default-time="16:00:00"
              popper-class="noneMinute"
              :picker-options="quotationDeadlineTimeDate"
              @change="delayTimeChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="延时原因" prop="remark">
            <el-input
              v-model="delayForm.remark"
              type="textarea"
              maxlength="300"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" @click="closeDia('delayVisible')"
          >取消</el-button
        >
        <el-button
          v-prevent-re-click
          class="btn-80-30-primary"
          type="primary"
          @click="handleDelay('delayVisible')"
        >
          确定
        </el-button>
      </div>
    </prompt-modal>

    <!-- 审核记录弹窗 -->
    <audit-record
      :audit-record-visible.sync="auditRecordVisible"
      :row="auditRecordRow"
    />

    <!-- 报价供应商 -->
    <supplier-price
      :supplier-price-visible.sync="supplierPriceVisible"
      :params="supplierPriceRow"
    />
    <ai-review-detail
      :visible.sync="aiReviewModalStatus"
      :business-id="aiReviewId"
    />
  </div>
</template>
<script>
import utils from '@/modules/projectA/utils/utils';
import _ from 'lodash';
import Api from '@/modules/projectA/api/enquiry';
import api from '@/modules/projectA/api/order';
import { orderBaseUrl } from '@/modules/projectA/api/config';
import AiReviewDetail from '@/modules/projectA/components/aiReviewDetail';
// 删除弹窗
import PromptModal from '@/modules/projectA/components/common/promptModal';
import eSearch from '@/modules/projectA/components/common/e-search';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import AuditRecord from '../components/auditRecord.vue';
import SupplierPrice from '../components/supplierPrice.vue';

import { tableLabel, fieldList, listTypeInfo } from './componentsData.js';

const enquiryStatusObj = {
  // 生成订单
  0: '草稿', // 已保存
  1: '待平台审核', // 有
  2: '待报价', // 有
  3: '待揭示', // 有
  4: '已揭示', // 有
  5: '询价完成', // 有
  /* 6: "生成订单", // 已下单 */
  7: '生成订单', // 有
  8: '询价作废', // 没有
  9: '审核拒绝', // 有
  10: '询价过期', // 没有
  11: '待审批', // 新
  12: '选商定价待审批',
  13: '审批拒绝',
  14: '中选通知待确认',
};
const enquiryTypeObj = {
  0: '定向询价',
  1: '公开询价',
};
const createSourceTypeObj = {
  0: '平台询价',
  1: '平台询价',
  2: '石化询价',
};
const includeFreightTypeObj = {
  0: '包含在商品中',
  1: '单独明细提报',
};
const isDoCeObj = {
  0: '款到发货',
  1: '货到付款',
};
const shipmentTypeObj = {
  1: '卖家自行配送',
  3: '第三方物流',
};
export default {
  name: 'EnquiryManagePur',
  components: {
    PromptModal,
    AuditRecord,
    SupplierPrice,
    eSearch,
    eTableList,
    AiReviewDetail,
  },
  data() {
    return {
      tableLabel,
      fieldList,
      listTypeInfo,
      delayForm: { remark: '', quotationDeadline: '' },
      delayRules: {
        quotationDeadline: [
          { required: true, message: '请选择时间', trigger: 'change' },
        ],
      },
      supplierPriceVisible: false,
      supplierPriceRow: {},

      auditRecordRow: {},
      auditRecordVisible: false,
      // 作废vis
      cancellationVis: false,
      // 询比价状态
      enquiryStatusObj,
      // 询价类型
      enquiryTypeObj,
      createSourceTypeObj,
      includeFreightTypeObj,
      isDoCeObj,
      shipmentTypeObj,
      productDetail: {},
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        enquiryName: null,
        enquiryNo: null,
        enquiryStatus: null,
        enquiryType: 0,
        time: null,
        isDoC: null,
        shipmentType: null,
        createSource: null,
        includeFreight: null,
        createModeList: [0, 1, 2, 3, 4, 5],
      },
      total: 0,
      cloneListQuery: {},
      tabArr: [
        { tabName: '定向询价', badge: 0 },
        { tabName: '公开询价', badge: 0 },
      ],
      currentIndex: '0',
      tableData: [],
      // 删除
      delVisible: false,
      paramsRow: {},
      // 撤回
      withdrawVisible: false,
      // 回退
      backVisible: false,
      // 延迟
      delayVisible: false,
      quotationDeadlineTimeDate: {
        disabledDate: (time) => {
          // const today = new Date().setHours(0, 0, 0, 0);
          if (!this.paramsRow.quotationDeadline) return;
          const today = new Date(this.paramsRow.quotationDeadline).getTime();
          // eslint-disable-next-line consistent-return
          return (
            /* time.getTime() < today + 1 * (24 * 60 * 60 * 1000) ||
            time.getTime() > today + 15 * (24 * 60 * 60 * 1000) */
            time.getTime() < today - 1 * (24 * 60 * 60 * 1000) ||
            time.getTime() > today + 15 * (24 * 60 * 60 * 1000)
          );
        },
      },
      payTypeOptions: [
        { label: '全部', value: null },
        { label: '款到发货', value: 0 },
        { label: '货到付款', value: 1 },
      ],
      shipmentTypeOptions: [
        { label: '全部', value: null },
        { label: '卖家自行配送', value: 1 },
        { label: '第三方物流', value: 3 },
      ],
      tableLoading: false,
      createSourceOptions: [
        { label: '全部', value: null },
        { label: '平台询价', value: 0 },
        { label: '石化询价', value: 1 },
      ],
      enquiryConfig: {
        isPurchaserAdmin: false,
        inquirySheetLook: '10', // 询价单查看权限设置（10：所有询价单；20：仅查看下单人询价单）
        inquirySheetOperate: '11', // 询价单操作权限设置（11：支持互相操作；12：仅支持下单人操作）
      },

      uniqueId: `${this.$route.query.t}`,

      configData: '',
      aiReviewId: '',
      aiReviewModalStatus: false,
      isOpenAiReview: false,
    };
  },
  computed: {
    cancellationTitle() {
      return this.currentIndex === '0'
        ? '您的操作将作废报价单据，这条单据下所有报价信息均将认作失效，此操作无法恢复，是否继续？'
        : '您的操作将作废报价单据，这条单据下所有报价信息均将认作失效，此操作无法恢复，是否继续？';
    },
    formatTableLabel({ isOpenAiReview }) {
      // 控制当前列表columns是否显示AI辅助审查列
      const columns = _.cloneDeep(this.tableLabel);
      if (isOpenAiReview) {
        columns.forEach((item, index) => {
          if (item.param === 'delaysCount') {
            columns.splice(index + 1, 0, {
              label: 'AI辅助审查',
              param: 'aiReviewStatus',
              align: 'center',
              slot: 'aiReviewStatus',
              minWidth: 140,
            });
          }
        });
      }
      return columns;
    },
  },
  async created() {
    this.queryCompanyOnpenAiReview();
    try {
      const res = await Api.getInquirySheetConfigAndIsBuyerAdmin();
      if (res.success) this.enquiryConfig = res.data;
    } catch {
      console.log('getInquirySheetConfigAndIsBuyerAdmin Error!');
    }
    const { isPurchaserAdmin, inquirySheetLook } = this.enquiryConfig;
    this.listQuery = {
      ...this.listQuery,
      whetherOnlyOneself: inquirySheetLook === '10' ? 0 : 1,
      whetherAdmin: isPurchaserAdmin ? 1 : 0,
    };

    this.cloneListQuery = utils.cloneDeep(this.listQuery);
    this.getList(this.listQuery);
  },
  activated() {
    const time = `${this.$route.query.t}`;
    if (time && time !== this.uniqueId) {
      this.uniqueId = time;
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    }
  },
  methods: {
    // 改变时间控制此刻是否能选
    delayTimeChange(val) {
      console.log(new Date(this.paramsRow.quotationDeadline).getTime() > val);
      if (
        this.paramsRow.quotationDeadline &&
        new Date(this.paramsRow.quotationDeadline).getTime() > val
      ) {
        this.delayForm.quotationDeadline = '';
      }
    },
    handleExport: _.debounce(async function () {
      const result = await api.exportEnquiryInfo({
        ...this.listQuery,
        createSource: null,
      });
      if (result?.code === '500') {
        return;
      }
      if (result.type == 'application/json') {
        utils.fileExportResponseError(result);
      } else {
        const time = utils.formatDate(new Date(), 'yyyyMMdd');
        utils.downFile(result, `询价单信息${time}`);
      }
    }),

    checkAuth(row) {
      const { memberId } = this.$store.state.USERINFO;
      if (this.enquiryConfig.isPurchaserAdmin) return true;
      if (this.enquiryConfig.inquirySheetOperate === '11') {
        return true;
      }
      if (row.createMemberId === memberId) {
        return true;
      }
      this.$message.warning(
        '企业设置不支持操作其他人的询价单，如有问题请联系采购管理员修改设置。'
      );
      return false;
    },
    quotationDeadlineChange(val) {
      console.log(1111);
    },
    showSupplierPrice(row) {
      // 公开报价
      if (row.enquiryType === 1) {
        console.log(row.quotationCount, '公开询价');
        // return row.quotationCount === 0 ? '0' : row.quotationCount;
        return row.quotationCount === 0 ? '0' : row.quotationCount;
      }
      console.log('定向询价');
      // 定向询价
      if (row.quotationCount === 0) {
        return `0/${row.offerCount}`;
      }
      console.log(`${row.quotationCount}/${row.offerCount}`);
      return `${row.quotationCount}/${row.offerCount}`;
    },
    // 查看报价供应商
    openSupplierPriceDia(row) {
      this.supplierPriceVisible = true;
      this.supplierPriceRow = { ...row };
    },
    goOrder(row) {
      console.log(row);
      const { enquiryId, createMode = '' } = row;
      const enquiryOrder =
        createMode === 2 ? 'myPurchaseRequest' : 'enquiryOrder';

      // window.open(
      //   `${mallBaseUrl}/order?enquiryId=${enquiryId}&flag=${enquiryOrder}&createMode=${createMode}`,
      //   '_blank'
      // );

      window.open(
        `${orderBaseUrl}/order?from=e&enquiryId=${enquiryId}&flag=${enquiryOrder}&createMode=${createMode}`,
        '_blank'
      );
    },
    openAuditRecordDia(row) {
      this.auditRecordVisible = true;
      this.auditRecordRow = { ...row };
      console.log(this.auditRecordRow, 'this.auditRecordRow');
    },

    async updateViewOfferCount(enquiryId) {
      console.log('调了接口', enquiryId);
      const result = Api.updateViewOfferCount({ enquiryId });
      if (result.code === '200') {
        console.log(result, 'result');
      }
    },
    // 选商定价 列表操作跳转
    async chooseBusPrc(row) {
      const {
        enquiryId = '',
        enquiryStatus = '',
        createMode = '',
        viewOfferCount = undefined,
        purchaseCompanyId,
      } = row;
      if (viewOfferCount === 0 && row.isCanDelay === 1) {
        this.$confirm(
          '您正在操作选商定价，查看供应商报价信息后无法再操作延时功能，是否继续？',
          '选商定价',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            this.updateViewOfferCount(enquiryId);
            this.$router.push({
              path: '/enquiryManage/enquiry/chooseBusinessPrice',
              query: {
                enquiryId,
                enquiryStatus,
                createMode,
                purchaseCompanyId,
              },
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            });
          });
      } else {
        this.updateViewOfferCount(enquiryId);
        this.$router.push({
          path: '/enquiryManage/enquiry/chooseBusinessPrice',
          query: {
            enquiryId,
            enquiryStatus,
            createMode,
            purchaseCompanyId,
          },
        });
      }
    },

    // 询价列表 肯定是采购商的  报价列表肯定是供应商的
    // 删除操作
    handleDel() {
      // double_identity 双重身份  supplier  供应商  purchase
      // this.$store.state.USERINFO.
      const method =
        this.paramsRow.enquiryStatus === 8
          ? 'removeEnquiryPur'
          : 'removeEnquiry';
      Api[method]({ enquiryId: this.paramsRow.enquiryId }).then((res) => {
        if (res.code === '200') {
          this.listQuery = { ...this.cloneListQuery };
          this.listQuery.enquiryType = this.currentIndex === '0' ? 0 : 1;
          this.getList(this.listQuery);
          this.delVisible = false;
        }
      });
    },

    // tab切换
    handleTab(tab, event) {
      this.currentIndex = tab.index;
      this.listQuery.pageNum = 1;
      if (this.currentIndex === '0') {
        this.listQuery.enquiryType = 0;
      } else {
        this.listQuery.enquiryType = 1;
      }
      this.getList(this.listQuery);
    },
    // 查看详情
    async handleViewDetail(row) {
      const { enquiryId, enquiryStatus, purchaseCompanyId } = row;
      this.$router.push({
        path: '/enquiryManage/enquiry/enquiryDetail',
        query: {
          enquiryId,
          enquiryStatus,
          purchaseCompanyId,
        },
      });
    },
    // 获取列表数据
    async getList(params) {
      try {
        Api.queryPriceSupplierConfig().then((res) => {
          console.log('res:', res);
          this.configData = res.data?.data || '131';
        });

        this.tableLoading = true;
        await Api.queryEnquiryList(params).then((res) => {
          if (res.code === '200') {
            const { data } = res;
            this.tableData = [...data?.records];
            this.total = data?.total;
          }
        });
      } finally {
        this.tableLoading = false;
      }
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.listQuery.enquiryType = this.currentIndex === '0' ? 0 : 1;
      this.getList(this.listQuery);
    },
    // 搜索
    handleQuery(val) {
      console.log(val);
      if (val.time?.length) {
        val.quotationDeadlineEnd = val.time[1];
        val.quotationDeadlineStart = val.time[0];
      } else {
        val.quotationDeadlineEnd = null;
        val.quotationDeadlineEnd = null;
      }
      if (val.createTime?.length) {
        val.createEndTime = val.createTime[1];
        val.createStartTime = val.createTime[0];
      } else {
        val.createStartTime = null;
        val.createStartTime = null;
      }
      // releaseTime
      if (val.releaseTime?.length) {
        val.releaseTimeEnd = val.releaseTime[1];
        val.releaseTimeStart = val.releaseTime[0];
      } else {
        val.releaseTimeStart = null;
        val.releaseTimeEnd = null;
      }
      for (const item in val) {
        if (val[item] === '') {
          val[item] = null;
        }
      }
      val.enquiryType = this.currentIndex === '0' ? 0 : 1;
      val.createSourceList = !Number.isInteger(val.createSource)
        ? null
        : val?.createSource === 0
        ? [0, 1]
        : [2];
      this.listQuery = { ...val, pageNum: 1 };
      this.getList({ ...this.listQuery, createSource: null });
    },
    // 编辑
    handleEdit(row) {
      const { enquiryId, createMode = '' } = row;
      this.$router.push({
        path: `/enquiryManage/enquiry/releaseEnquiry`,
        query: { enquiryId, createMode },
      });
    },
    // 揭示
    handleReveal() {
      this.$router.push({
        path: '/enquiryManage/enquiry/enquiryRevealPricing',
        qeury: {},
      });
    },
    // 作废 弹窗操作
    async handleCancellation() {
      /*
        作废参数
        "enquiryId": 0,
        "enquiryStatus": 0,
        "offerStatus": 0,
        "purchaseCompanyId": 0
      */
      const {
        enquiryId = '',
        enquiryStatus = '',
        offerStatus = '',
        purchaseCompanyId = '',
      } = this.paramsRow;
      const params = {
        enquiryId,
        enquiryStatus,
        offerStatus,
        purchaseCompanyId,
      };
      await Api.cancelEnquiry(params).then((res) => {
        if (res.code === '200') {
          this.getList(this.listQuery);
          this.cancellationVis = false;
        }
      });
    },
    openDia(type, row) {
      this[type] = true;
      this.paramsRow = { ...row };
      console.log(this.paramsRow, 'this.paramsRow');
    },
    // 关闭弹窗
    closeDia(type) {
      this[type] = false;
      this.paramsRow = {};
      if (type === 'delayVisible') {
        this.$refs.delayForm.resetFields();
      }
    },
    // 撤回操作
    async handleWithdraw(type) {
      await Api.callbackEnquiry({ enquiryId: this.paramsRow.enquiryId }).then(
        (res) => {
          if (res.code === '200') {
            this.listQuery = { ...this.cloneListQuery };
            this.listQuery.enquiryType = this.currentIndex === '0' ? 0 : 1;
            this.getList(this.listQuery);
            this.closeDia(type);
          }
        }
      );
    },
    // 延时操作
    handleDelay(type) {
      this.$refs.delayForm.validate(async (valid) => {
        if (valid) {
          try {
            const params = {
              remark: this.delayForm.remark,
              enquiryId: this.paramsRow.enquiryId,
              newEnquiryChangeDataAO: {
                quotationDeadline: this.delayForm.quotationDeadline,
              },
            };
            const result = await Api.changeSupplierOfferDelay(params);
            if (result.code === '200') {
              this.closeDia(type);
              this.listQuery = { ...this.cloneListQuery };
              this.listQuery.enquiryType = this.currentIndex === '0' ? 0 : 1;
              this.getList(this.listQuery);
            }
          } catch (err) {
            console.log(err);
          }
        } else {
          return false;
        }
      });
    },
    // 回退
    async handleBack(type) {
      await Api.returnEnquiry({ enquiryId: this.paramsRow.enquiryId }).then(
        (res) => {
          if (res.code === '200') {
            this.listQuery = { ...this.cloneListQuery };
            this.listQuery.enquiryType = this.currentIndex === '0' ? 0 : 1;
            this.getList(this.listQuery);
            this.closeDia(type);
          }
        }
      );
    },
    // 打开AI审查详情
    openAiReviewModal({ enquiryNo = '' } = {}) {
      this.aiReviewId = enquiryNo;
      if (enquiryNo) {
        this.aiReviewModalStatus = true;
      } else {
        this.aiReviewModalStatus = false;
      }
    },
    // 是否能够使用AI审查功能的状态获取
    queryCompanyOnpenAiReview() {
      api.queryCompanyOnpenAiReview().then((res) => {
        if (res.code === '200') {
          this.isOpenAiReview = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss">
.noneMinute {
  .el-time-spinner__wrapper {
    width: 100% !important;
  }
  .el-scrollbar:nth-of-type(2) {
    display: none;
  }
}
.el-message-box {
  border-radius: 0;
}
.el-button {
  border-radius: 0;
}
</style>
<style lang="scss" scoped>
.enquiry-manage {
  background: #fff;
  padding: 20px;
  flex: 1;
  flex-direction: column;
  .tab-box {
    display: flex;
    align-items: center;
    .tab-btn {
      width: 234px;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      // border: 1px solid #DCDFE6;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      padding: 12px 20px;
      font-size: 14px;
      // border-radius: 4px;
      border-top: 1px solid #d9d9d9;
      border-left: 1px solid #d9d9d9;
      &:last-child {
        border-right: 1px solid #d9d9d9;
      }
      &.active {
        position: relative;
        background: #f4f7ff;
        color: #0064c8;
        border-top: 2px solid #0064c8;
        border-bottom: 0;
        z-index: 10;
      }
    }
  }
  .search-box {
    padding: 10px;
    width: 100%;
    border: 1px solid #d9d9d9;
    position: relative;
    top: -1px;
    .search-form {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        flex: 0 0 316px;
      }
      ::v-deep .el-input {
        width: 200px;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-date-editor {
        border-radius: 0;
      }
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      }
    }
  }
  .handle-box {
    display: flex;
    justify-content: end;
    margin: 10px 0;
    .default-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }
    .right {
      float: right;
    }
  }
  .table-box {
    .table-handle-btn {
      color: #0064c8;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .err-btn {
      color: #f0250f;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog {
    margin-top: 0 !important;
    top: 50%;
    transform: translateY(-50%);
  }
  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .el-button {
      border-radius: 0;
      min-width: 80px;
      padding: 0;
      height: 30px;
      line-height: 28px;
      font-size: 14px;
    }
  }
  ::v-deep .cell {
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    text-align: center;
  }

  ::v-deep .el-table__header-wrapper {
    height: 40px;
    background: #f5f5f5;
  }
  ::v-deep .el-table__body-wrapper {
    .empty {
      text-align: center;
      margin-bottom: 80px;
      img {
        margin-top: 60px;
        width: 204px;
        height: 124px;
      }
      p {
        height: 24px;
        line-height: 24px;
        margin-top: 10px;
        color: #333;
        font-size: 16px;
        span {
          color: #2587ff;
          cursor: pointer;
        }
      }
    }
  }
  ::v-deep .el-table th {
    padding: 0;
    height: 40px;
    background: #f5f5f5;
  }
  ::v-deep .el-table td {
    padding: 0;
    height: 50px;
  }
  .prompt-modal-title {
    display: flex;
    height: 40px;
    padding-left: 20px;
    align-items: center;
    img {
      width: 18px;
      height: 18px;
      margin-right: 10px;
      vertical-align: middle;
    }
    p {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      line-height: 14px;
    }
  }
  .prompt-modal-content {
    > h4 {
      font-weight: 500;
      color: #333;
      margin-bottom: 5px;
    }
  }
}
</style>
